import PostViewer from './PostViewer';

export default PostViewer;
